import axios from 'axios'
import { getValidToken } from './tokenManager.helper'

// Create axios instance with interceptors
const apiClient = axios.create()

// Request interceptor to add valid token to all requests
apiClient.interceptors.request.use(
  async (config) => {
    // Skip token for login/register/refresh endpoints
    if (config.url.includes('/user/login') ||
        config.url.includes('/user/register') ||
        config.url.includes('/auth/refresh') ||
        config.url.includes('/user/recover-password')) {
      return config
    }

    try {
      const { token } = await getValidToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch (error) {
      console.error('Failed to get valid token for request:', error)
      // Don't throw here, let the request proceed and handle 401 responses
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config

    // If we get a 401 and haven't already tried to refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        // Try to refresh the token
        const { token } = await getValidToken()
        if (token) {
          // Update the original request with new token
          originalRequest.headers.Authorization = `Bearer ${token}`
          // Retry the original request
          return apiClient(originalRequest)
        }
      } catch (refreshError) {
        console.error('Token refresh failed in interceptor:', refreshError)
        // Clear stored data and redirect to login
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('client')
        window.location.href = '/'
      }
    }

    return Promise.reject(error)
  }
)

export default apiClient
